import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Interceptor } from '../auth/services/interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from 'environments/environment';
import { GlobalErrorHandlerService } from '../services/global-error-handler.service';
import { EncodeHttpParamsInterceptor } from '../auth/services/encode-http-params-interceptor';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { SafeHtmlPipe } from '../pipes/safeHtml.pipe';
import { ShortenPipe } from '../pipes/shorten.pipe';

@NgModule({
  declarations: [SafeHtmlPipe, ShortenPipe],
  imports: [CommonModule, ScrollingModule],
  exports: [SafeHtmlPipe, ShortenPipe],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true
    }
  ]
})
export class StartModule {}
